import { render, staticRenderFns } from "./salesCounter.vue?vue&type=template&id=58ea1836&scoped=true&"
import script from "./salesCounter.vue?vue&type=script&lang=js&"
export * from "./salesCounter.vue?vue&type=script&lang=js&"
import style0 from "./salesCounter.vue?vue&type=style&index=0&id=58ea1836&prod&scoped=true&lang=css&"
import style1 from "./salesCounter.vue?vue&type=style&index=1&id=58ea1836&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ea1836",
  null
  
)

export default component.exports